// extracted by mini-css-extract-plugin
export default {"footer":"footer--ZDeQJ","images-wrapper":"images-wrapper--xN33Z","imagesWrapper":"images-wrapper--xN33Z","texts-wrapper":"texts-wrapper--TirPN","textsWrapper":"texts-wrapper--TirPN"};